import { useMemo } from 'react';
import { density, type DensityMode } from '@vitness/tokens';
import { useTheme } from './ThemeProvider.js';

export type DensityTokens = (typeof density)[DensityMode];

export interface DensityValue {
  mode: DensityMode;
  tokens: DensityTokens;
  setDensity: (mode: DensityMode) => void;
}

export function useDensity(): DensityValue {
  const { density: mode, setDensity } = useTheme();

  return useMemo(() => ({
    mode,
    tokens: density[mode],
    setDensity,
  }), [mode, setDensity]);
}
